/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = [".button-container[_ngcontent-%COMP%]{padding-top:5rem}.header[_ngcontent-%COMP%]{font-size:2rem;padding-bottom:5rem}.message-container[_ngcontent-%COMP%]{background-color:#4c5a66;color:#fff;height:100%;position:absolute;top:50%;left:50%;-webkit-transform:translate(-50%,-50%);transform:translate(-50%,-50%);width:100%;padding:3rem 5rem}@media (min-width:801px){.message-container[_ngcontent-%COMP%]{height:50%;width:50%}}"];
export { styles as styles };
